<template>
  <div style="padding-bottom: 10rem; background: #ffffff;">
    <!-- HEADER -->
    <AppHeader
      :title="$store.state.language === 'en' ? 'Match Result' : 'ပွဲပြီးရလဒ်များ'"
      :show-back="true"
      :has-actions="true"
    />

    <!-- TABS -->
    <div class="container d-flex justify-content-center mt-4">
      <div v-if="todayMatches.length > 0 || yesterdayMatches.length > 0">
        <div class="tabs">
          <button
            class="tab-button"
            :class="{ active: tab === 'Yesterday' }"
            @click="openTab('Yesterday')"
          >
            Yesterday
          </button>
          <button
            class="tab-button"
            :class="{ active: tab === 'Today' }"
            @click="openTab('Today')"
          >
            Today
          </button>
        </div>
      </div>

      <!-- LOADING -->
      <div v-else class="text-center mt-5">
        <Loading color="#ca8a04" size="24" />
        <p class="mt-2 text-muted">
          {{ $store.state.language === 'en'
            ? 'Fetching football matches…'
            : 'ဘောလုံးပွဲစဉ်များအား ရယူနေပါသည်…' }}
        </p>
      </div>
    </div>

    <!-- MATCH LIST -->
    <div class="container mt-3">
      <div
        class="match-card"
        v-for="(item, index) in tab === 'Today' ? todayMatches : yesterdayMatches"
        :key="index"
      >
        <div class="p-3">
          <!-- LEAGUE -->
          <div class="text-center mb-2">
            <h4 class="league-title">{{ item.league }}</h4>
          </div>

          <!-- TEAMS -->
          <div class="d-flex justify-content-around align-items-center">
            <div class="team-name">
              {{ item.first_team }}
            </div>

            <!-- CENTER -->
            <div class="match-center">
              <span v-if="item.is_result" class="result-ft">FT</span>

              <span v-if="!item.is_result" class="result-vs">VS</span>

              <span
                v-if="item.is_result && !item.is_cancel"
                class="result-score"
              >
                {{ item.first_team_result }} - {{ item.second_team_result }}
              </span>

              <span v-if="item.is_cancel" class="result-pp">PP</span>

              <p class="match-time">
                {{ matchTime(item.start_time) }}
              </p>
            </div>

            <div class="team-name">
              {{ item.second_team }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'vant'
import AppHeader from './components/AppHeader.vue'

export default {
  components: { Loading, AppHeader },
  data() {
    return {
      tab: 'Today',
      todayMatches: [],
      yesterdayMatches: []
    }
  },
  methods: {
    openTab(tabName) {
      this.tab = tabName
    },
    matchTime(startTime) {
      const date = new Date(startTime)
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      })
    },
    async fetchMatches() {
      try {
        const res = await axios.get('fb-matches-history', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        this.todayMatches = res.data.data.today
        this.yesterdayMatches = res.data.data.yesterday
      } catch (e) {
        console.error(e)
      }
    }
  },
  mounted() {
    this.fetchMatches()
  }
}
</script>

<style scoped>
/* ===============================
   BASE
================================ */
.match-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  margin-bottom: 1rem;
  transition: box-shadow 0.2s ease;
}

.match-card:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

/* ===============================
   LEAGUE
================================ */
.league-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

/* ===============================
   TEAMS
================================ */
.team-name {
  width: 130px;
  text-align: center;
  font-weight: 600;
  color: #111827;
  font-size: 15px;
}

/* ===============================
   CENTER RESULT
================================ */
.match-center {
  text-align: center;
  min-width: 80px;
}

.result-ft {
  font-size: 12px;
  font-weight: 700;
  color: #92400e;
  letter-spacing: 1px;
}

.result-score {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
}

.result-vs {
  display: inline-block;
  padding: 4px 14px;
  background: #fffbeb;
  color: #92400e;
  border: 1px solid #fde68a;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.result-pp {
  font-size: 12px;
  font-weight: 700;
  color: #ca8a04;
  letter-spacing: 1px;
}

/* ===============================
   TIME
================================ */
.match-time {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 4px;
}

/* ===============================
   TABS
================================ */
.tabs {
  display: flex;
  background: #f9fafb;
  border-radius: 999px;
  padding: 4px;
  gap: 4px;
  width: 280px;
  border: 1px solid #e5e7eb;
}

.tab-button {
  flex: 1;
  background: transparent;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  transition: all 0.2s ease;
  width: 10rem;
}

.tab-button.active {
  background: #92400e;
  color: #ffffff;
}

/* .tab-button:hover {
  background: #dcfce7;
} */

/* ===============================
   MOBILE
================================ */
@media (max-width: 768px) {
  .team-name {
    font-size: 14px;
  }

  .result-score {
    font-size: 1.1rem;
  }

  .tabs {
    width: 100%;
  }
}
</style>
